<section class="dz-row max-height">
	<ng-container *ngFor="let item of skeletonArray">
		<section
			[ngClass]="{
				'dz-col-12': modelsCount === 1,
				'dz-col': modelsCount === 2
			}"
		>
			<div class="compare-card-skeleton">
				<div class="title-bar"></div>
				<div class="desc-bar"></div>
			</div>
		</section>
	</ng-container>
</section>
